import type { Event } from '@ori-events/toggle-favorite';
import { Name } from '@ori-events/toggle-favorite';
import { useCallback } from 'react';

import { useDebouncedAddEventListener } from './useDebouncedAddEventListener';
import type { useFavorites } from './useFavorites';
import { dispatchFavoritesUpdatedEvent } from '../utils';

export const useToggleEvent = (toggle: ReturnType<typeof useFavorites>['toggle']) => {
  const onToggle = useCallback(
    ({ detail: { code } }: Event) => {
      toggle(code)
        .then(({ favorites }) => dispatchFavoritesUpdatedEvent({ favorites, lastUpdated: code }))
        // eslint-disable-next-line no-console -- log error to console
        .catch(console.error);
    },
    [toggle],
  );
  useDebouncedAddEventListener(Name, onToggle);
};
